export const SIDE_NAV_WIDTH_DESKTOP = 230;
export const SUB_SIDE_NAV_WIDTH_DESKTOP = 318;

export const TOP_NAV_HEIGHT_DESKTOP = 49;
export const TOP_NAV_HEIGHT_MOBILE = 56;
